var app = angular.module("leonardo");

var AdminLogin = function($stateProvider) {
  $stateProvider.state('admin-login', {
    parent: 'layout-no-cols',
    url: "/admin-login",
    cssClass: 'page-home',
    resolve: {
      tokenLogin: ['$location', '$state', '$timeout', 'CacheService', 'FilterService',
      function($location, $state, $timeout, CacheService, FilterService) {
        var token = $location.search().token;
        
        if (!token) {
          $timeout(function() {
            $state.go('home', {}, { location: 'replace' });
          }, 0);
          return;
        }

        CacheService.clearAll();
        FilterService.resetFilters(true);
        localStorage.setItem('jwt_token', token);
        localStorage.setItem('auth_provider', 'admin');

        $timeout(function() {
          $state.go('home', {}, { location: 'replace' });
        }, 0);
      }]
    },
    views: {
      'content': {
        template: '<div class="loading-container"><p>Logging in...</p></div>'
      }
    },
    public: true
  });
};

app.config(['$stateProvider', AdminLogin]);
